
import Vue from 'vue';

export default Vue.extend({
  functional: true,
  props: {
    label: String,
    counter: String,
  },
  render(h, ctx) {
    const wordsArray = ctx.props.label.split(' ');
    let renderedElement;
    if (wordsArray.length < 2) {
      renderedElement = [
        h('span', {
          class: 'item-label',
          domProps: {
            innerHTML: ctx.props.label,
          },
        }),
        h('span', {
          class: 'counter',
          domProps: {
            innerHTML: ` ${ctx.props.counter}`,
          },
        }),
      ];
    } else {
      const end = wordsArray.pop();
      const start = `${wordsArray.join(' ')}`;
      const childs = [];
      childs.push(h('span', {
        class: 'item-label',
        domProps: {
          innerHTML: ` ${end}`,
        },
      }));
      childs.push(h('span', {
        class: 'counter',
        domProps: {
          innerHTML: ` ${ctx.props.counter}`,
        },
      }));
      renderedElement = [
        h('span', {
          class: 'item-label',
          domProps: {
            innerHTML: start,
          },
        }),
        h('span', {
          class: 'item-holder',
        }, childs),
      ];
    }

    return renderedElement;
  },
});
